export default [
  {
    id: 1,
    url: "/enterprise/live-map",
    slug: "live-map",
    icon: "MapIcon",
    i18n: "SideMenu.Maps",
    isAddon: false,
    isFreeContent: true,
  },
  {
    id: 2,
    url: "/enterprise/plot-list",
    slug: "plot-list",
    icon: "MapPinIcon",
    localIcon: false,
    localUrl: null,
    disabledLocalUrl: require("@/assets/images/icons/lolcal/plot_lock.svg"),
    i18n: "SideMenu.Plots",
    isAddon: false,
  },
  {
    id: 3,
    url: "/enterprise/voyage-histories",
    slug: "voyage-histories",
    icon: "FilmIcon",
    localIcon: false,
    localUrl: null,
    disabledLocalUrl: require("@/assets/images/icons/lolcal/voyage_history_lock.svg"),
    i18n: "SideMenu.VoyageHistories",
    isAddon: false,
  },
  {
    id: 4,
    url: "/enterprise/management/user-list",
    slug: "users",
    icon: "UsersIcon",
    localIcon: false,
    localUrl: null,
    disabledLocalUrl: require("@/assets/images/icons/lolcal/users_lock.svg"),
    i18n: "SideMenu.Enterprise.Users",
    isAddon: false,
  },
  {
    id: 5,
    url: "/enterprise/management/vessel-list",
    slug: "vessels",
    localIcon: true,
    localUrl: require("@/assets/images/icons/lolcal/ship.svg"),
    disabledLocalUrl: require("@/assets/images/icons/lolcal/ship_lock.svg"),
    icon: "ship",
    i18n: "SideMenu.Enterprise.Vessels",
    isAddon: false,
  },
  {
    url: "/enterprise/addon/vessel-noon-report-list",
    name: "動静連絡",
    slug: "Enterprise_Vessel_Noon_Report",
    tagColor: "primary",
    icon: "FileTextIcon",
    i18n: "SideMenu.Enterprise.VesselNoonReport",
    isAddon: true,
  },
  {
    id: 6,
    url: "/enterprise/management/camera-list",
    slug: "camera",
    icon: "VideoIcon",
    localIcon: false,
    localUrl: null,
    disabledLocalUrl: require("@/assets/images/icons/lolcal/camera_lock.svg"),
    i18n: "SideMenu.Enterprise.Camera",
    isAddon: false,
  },
  {
    id: 7,
    url: "/enterprise/management/notification-list",
    tag: "",
    tagColor: "primary",
    slug: "notification",
    icon: "BellIcon",
    i18n: "SideMenu.Enterprise.Notification",
    isAddon: false,
    isFreeContent: true,
  },
  {
    header: "入出港管理",
    icon: "AnchorIcon",
    i18n: "SideMenu.Enterprise.Addons.PortManagement",
    isAddon: true,
    slug: "PortMaster",
    items: [
      {
        url: "/enterprise/addon/port-master-port-menu",
        name: "Port Master",
        slug: "PortMaster",
        tagColor: "primary",
        icon: "AnchorIcon",
        i18n: "SideMenu.Enterprise.Addons.PortMaster",
        isAddon: true,
      },
    ],
  },
  {
    header: "船舶動静連絡",
    icon: "LayersIcon",
    i18n: "SideMenu.Enterprise.Addons.VesselReport",
    isAddon: true,
    slug: "VesselReport",
    items: [
      {
        url: "/enterprise/addon/vessel-report-list",
        name: "船舶動静連絡",
        slug: "VesselReport",
        tagColor: "primary",
        icon: "EditIcon",
        i18n: "SideMenu.Enterprise.Addons.ReportList",
        isAddon: true,
      },
      {
        url: "/enterprise/addon/vessel-report-export",
        name: "船舶動静連絡",
        slug: "VesselReport",
        tagColor: "primary",
        icon: "FileTextIcon",
        i18n: "SideMenu.Enterprise.Addons.VesselReportExport",
        isAddon: true,
      },
    ],
  },
  {
    header: "損害対応",
    icon: "ClipboardIcon",
    i18n: "SideMenu.Enterprise.Addons.HullInsrance",
    tag: "",
    tagColor: "primary",
    slug: "Enterprise_Hull_Insurance",
    items: [
      {
        url: "/enterprise/addon/hull-insurance/claim-report-list",
        name: "事故一覧",
        localIcon: true,
        localUrl: require("@/assets/images/icons/lolcal/hull_insurance.svg"),
        slug: "Enterprise_Hull_Insurance",
        isAddon: true,
      },
    ],
    isAddon: true,
  },
  {
    header: "船舶性能",
    icon: "ClipboardIcon",
    i18n: "SideMenu.Enterprise.Addons.VesselPerformance",
    tag: "",
    tagColor: "primary",
    slug: "FuelConsumptionReport",
    items: [
      {
        url: "/enterprise/addon/fuel-consumption-vessel-list",
        name: "省エネレポート",
        localIcon: true,
        localUrl: require("@/assets/images/icons/lolcal/data_table.svg"),
        slug: "FuelConsumptionReport",
        isAddon: true,
      },
    ],
    isAddon: true,
  },
  {
    header: "EcoShip",
    icon: "LayersIcon",
    i18n: "SideMenu.Enterprise.Addons.EcoShip",
    isAddon: true,
    slug: "EcoShip",
    items: [
      {
        url: "/enterprise/addon/eco-ship/tank-liquid-level",
        name: "タンク液位管理",
        slug: "EcoShip",
        tagColor: "primary",
        icon: "BarChart2Icon",
        i18n: "SideMenu.Enterprise.Addons.TankLiquidLevel",
        isAddon: true,
      },
      {
        url: "/enterprise/addon/eco-ship-vessel-container-master",
        name: "リーファーコンテナ管理",
        slug: "EcoShip",
        tagColor: "primary",
        icon: "BoxIcon",
        i18n: "SideMenu.Enterprise.Addons.EcoShipContainer",
        isAddon: true,
      },
      {
        url: "/enterprise/addon/eco-ship-voyage-plan-list",
        name: "航路計画管理",
        slug: "EcoShip",
        tagColor: "primary",
        icon: "CompassIcon",
        i18n: "SideMenu.Enterprise.Addons.RoutePlan",
        isAddon: true,
      },
      {
        url: "/enterprise/addon/eco-ship/vessel-monitoring-engine-list",
        name: "機関データ",
        slug: "EcoShip",
        tagColor: "primary",
        icon: "ActivityIcon",
        i18n: "SideMenu.Enterprise.VesselMonitoringEngine",
        isAddon: true,
      },
      {
        url: "/enterprise/addon/eco-ship-fuel-consumption-list",
        name: "燃料消費量",
        slug: "EcoShip",
        tagColor: "primary",
        icon: "TrendingUpIcon",
        i18n: "SideMenu.Enterprise.Addons.FuelConsumption",
        isAddon: true,
      },
      {
        url: "/enterprise/addon/eco-ship-fuel-consumption-monthly-fuel-report",
        name: "燃料消費量(月次レポート)",
        slug: "EcoShip",
        tagColor: "primary",
        icon: "FileTextIcon",
        i18n: "SideMenu.Enterprise.Addons.FuelConsumptionMonthlyFuelReport",
        isAddon: true,
      },
      {
        url: "/enterprise/addon/eco-ship-fuel-consumption-yearly-fuel-report",
        name: "燃料消費量(統計レポート)",
        slug: "EcoShip",
        tagColor: "primary",
        icon: "FileTextIcon",
        i18n: "SideMenu.Enterprise.Addons.FuelConsumptionYearlyFuelReport",
        isAddon: true,
      },
    ],
  },
  {
    header: "監視",
    icon: "LayersIcon",
    i18n: "SideMenu.Enterprise.Addons.SecureDataflow.header",
    isAddon: true,
    slug: "SecureDataflow",
    items: [
      {
        url: "/enterprise/addon/secure-dataflow/monitoring-vessel-handling",
        name: "操船監視",
        slug: "SecureDataflow",
        tagColor: "primary",
        icon: "RadioIcon",
        i18n:
          "SideMenu.Enterprise.Addons.SecureDataflow.monitoringVesselManeuvering",
        isAddon: true,
      },
    ],
  },
  {
    header: "ユーティリティ",
    icon: "ClipboardIcon",
    i18n: "SideMenu.Enterprise.Addons.Utility",
    tag: "",
    tagColor: "primary",
    items: [
      {
        url: "/enterprise/task-manager",
        name: "タスクマネージャー",
        icon: "TrelloIcon",
        disabledLocalUrl: require("@/assets/images/icons/lolcal/taskmanager_lock.svg"),
        slug: "task-manager",
        localIcon: false,
        localUrl: null,
        isAddon: false,
      },
    ],
    isAddon: false,
  },
  {
    header: "Operation",
    i18n: "SideMenu.Enterprise.Addons.Operation",
    slug: "AiseaOperation",
    featureCode: "OPERATION",
    isAddon: true,
    items: [
      {
        id: 25,
        // ローカルホストで動かす場合は、ビルド時の VUE_APP_AISEA_WEB_URL を使用する
        url: `${process.env.VUE_APP_AISEA_WEB_URL || window.location.origin}/operation/reports`,
        slug: "AiseaOperation",
        i18n: "SideMenu.Enterprise.Addons.OperationList",
        tagColor: "primary",
        icon: "FileTextIcon",
        featureCode: "OPERATION_REPORT",
        isAddon: true,
        target: "_blank",
      },
    ],
  },
  {
    header: "安全文書管理",
    icon: "FileTextIcon",
    i18n: "SideMenu.Enterprise.Addons.SafetyDocument",
    slug: "Safety_Document",
    featureCode: "OPERATION_SAFETY_DOCUMENT",
    isAddon: true,
    items: [
      {
        id: 36,
        // ローカルホストで動かす場合は、ビルド時の VUE_APP_AISEA_WEB_URL を使用する
        url: `${process.env.VUE_APP_AISEA_WEB_URL || window.location.origin}/operation/safety-document`,
        name: "文書一覧",
        slug: "Safety_Document",
        addonSlug: "Safety_Document",
        tagColor: "primary",
        icon: "FileTextIcon",
        i18n: "SideMenu.Enterprise.Addons.SafetyDocumentList",
        featureCode: "OPERATION_SAFETY_DOCUMENT",
        isAddon: true,
        target: "_blank",
      },
      {
        id: 36,
        // ローカルホストで動かす場合は、ビルド時の VUE_APP_AISEA_WEB_URL を使用する
        url: `${process.env.VUE_APP_AISEA_WEB_URL || window.location.origin}/operation/tags`,
        name: "タグ管理",
        slug: "Safety_Document",
        addonSlug: "Safety_Document",
        tagColor: "primary",
        icon: "FileTextIcon",
        i18n: "SideMenu.Enterprise.Addons.SafetyDocumentTags",
        featureCode: "OPERATION_SAFETY_DOCUMENT",
        isAddon: true,
        target: "_blank",
      },
    ],
  },
  {
    header: "運航船労務管理",
    icon: "ClipboardIcon",
    i18n: "SideMenu.Enterprise.Addons.CrewOperator",
    tag: "",
    tagColor: "primary",
    slug: "Crew_Operator",
    featureCode: "OPERATION_CREW",
    items: [
      {
        url:
          "/enterprise/management/crew-operator/enterprise-management-vessel-dashboard",
        name: "運航船一覧",
        localIcon: true,
        localUrl: require("@/assets/images/icons/lolcal/crew_operator.svg"),
        slug: "Crew_Operator",
        featureCode: "OPERATION_CREW",
        isAddon: true,
      },
    ],
    isAddon: true,
  },
  {
    header: "船員管理",
    i18n: "SideMenu.Enterprise.Addons.CrewManagement",
    slug: "Menu_Group_Crew_Management",
    featureCode: "CREW",
    isAddon: true,
    items: [
      {
        // ローカルホストで動かす場合は、ビルド時の VUE_APP_AISEA_WEB_URL を使用する
        url: `${process.env.VUE_APP_AISEA_WEB_URL || window.location.origin}/crew/crew-management/crew-list`,
        slug: "Menu_Group_Crew_Management",
        icon: "UsersIcon",
        localIcon: false,
        i18n: "SideMenu.Enterprise.CrewSettings",
        featureCode: "CREW_CREW_SETTINGS",
        isAddon: true,
        isFreeContent: true,
        target: "_blank",
      },
      {
        url: `${process.env.VUE_APP_AISEA_WEB_URL || window.location.origin}/crew/assignment/dashboard`,
        name: "配乗管理",
        icon: "ListIcon",
        slug: "Crew_Assignment",
        i18n: "SideMenu.Enterprise.Addons.CrewAssignmentManagement",
        featureCode: "CREW_SCHEDULER",
        isAddon: true,
        isFreeContent: true,
        target: "_blank",
      },
      {
        url: `${process.env.VUE_APP_AISEA_WEB_URL || window.location.origin}/crew/labor/dashboard`,
        slug: "crews",
        localIcon: true,
        localUrl: require("@/assets/images/icons/lolcal/dashboad.svg"),
        i18n: "SideMenu.Enterprise.Crews",
        featureCode: "CREW_LABOR",
        isAddon: false,
        isFreeContent: true,
        target: "_blank",
      },
      {
        url: `${process.env.VUE_APP_AISEA_WEB_URL || window.location.origin}/crew/data/import-export`,
        name: "データ入出力",
        icon: "DownloadIcon",
        slug: "Crew_Data_Management",
        featureCode: "CREW_DATA_IO",
        isAddon: true,
        isFreeContent: true,
        target: "_blank",
      },
    ],
  },
];
